module.exports = __webpack_public_path__ + "img/temperature-testing-chambers-ur-332.42f360c2.jpg";